const main = resolve => require(['@/views/index/index.vue'], resolve) // 主页

const Invoice = resolve =>
  require(['@/views/settlement/invoice.vue'], resolve) // 月发票

const StatementDownload = resolve =>
  require(['@/views/settlement/statementDownload.vue'], resolve) // 商户对账单

const StatementSetting = resolve =>
require(['@/views/settlement/statementSetting.vue'], resolve) // 商户对账单

export default [
  {
    path: '/index',
    component: main,
    children: [

      // 月发票
      {
        name: 'Invoice',
        path: '/aq/invoice',
        alias: ['/aq/invoice.htm'],
        component: Invoice
      },
      //  商户对账单
      {
        name: 'StatementDownload',
        path: '/aq/statementDownload',
        alias: ['/aq/statementDownload.htm'],
        component: StatementDownload
      },
      //  商户对账单设置
      {
        name: 'StatementSetting',
        path: '/aq/statementSetting',
        alias: ['/aq/statementSetting.htm'],
        component: StatementSetting
      }
    ]
  }
]

